import React, { useContext, useMemo } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import EnterpriseNavigation from '../../../../components/EnterpriseNavigation';
import EnterpriseMembersContext from 'providers/EnterpriseMembers/EnterpriseMembers.context';
import { isSingleElementArray } from 'utils';
import useCreateSelectOptions from 'hooks/useCreateSelectOptions';
import useCallbackRef from 'hooks/useCallbackRef';
import { ModalRef } from 'ncoded-component-library/build/components/organisms/Modal/Modal.component';
import { ENTERPRISE_BUSINESS_UNIT } from '../../../../../Portfolio/components/PortfolioSellerFilters/data';
import { ENTERPRISE_MEMBER_INVITATION_STATUS } from 'models/Enterprises';
import { BROKER_STATUS, SENIORITY, BROKER_STATUS_TRANSLATION } from './data';
import { LIMIT_PARAM_KEYWORD } from 'data/global';
import { PER_PAGE } from 'components/NumberOfResultsPerPageFilter/NumberOfResultsPerPageFilter.component';
import { FilterOption } from 'models/Filters';
import { Button } from 'ncoded-component-library';
import FilterIcon from 'icons/Filter.icon';
import MultiFilterModal from 'components/MultiFilterModal';
import { ManagePeopleActions } from '../../../../../AdminDashboard/subrouters/Enterprises/subrouters/Enterprise/pages/ManagePeople/components/ManagePeopleActions';

import './TeamFilters.styles.scss';
import './TeamFilters.styles.responsive.scss';

type TeamFiltersProps = {
  className?: string;
  withNavigation?: boolean;
};

const TeamFilters: React.FC<TeamFiltersProps> = (props) => {
  const { className, withNavigation = true } = props;

  const [multiFilter, multiFilterRef] = useCallbackRef<ModalRef>();

  const classes = classNames('team-filters', className);

  const { units, memberSeniorities } = useContext(EnterpriseMembersContext);

  const { t } = useTranslation();
  const createSelectOptions = useCreateSelectOptions();

  const filterOptions = useMemo(
    () =>
      [
        ...(!isSingleElementArray(units)
          ? [
              {
                value: ENTERPRISE_BUSINESS_UNIT,
                label: t('businessUnit'),
                isMultiple: true,
                options: units,
              },
            ]
          : []),
        {
          value: BROKER_STATUS,
          label: t('status'),
          options: Object.values(ENTERPRISE_MEMBER_INVITATION_STATUS).map(
            (value) => ({
              value,
              label: t(BROKER_STATUS_TRANSLATION[value]),
            }),
          ),
        },
        ...(!isSingleElementArray(memberSeniorities)
          ? [
              {
                value: SENIORITY,
                label: t('seniority'),
                options: memberSeniorities,
              },
            ]
          : []),
        {
          value: LIMIT_PARAM_KEYWORD,
          label: t('limit'),
          options: createSelectOptions(PER_PAGE),
        },
      ] as FilterOption[],
    [units, t, memberSeniorities, createSelectOptions],
  );

  return (
    <div className={classes}>
      {withNavigation && <EnterpriseNavigation />}

      <div className="optional-filters">
        <ManagePeopleActions />
        <Button variant="icon" onClick={multiFilter?.open}>
          <FilterIcon />
        </Button>
        <MultiFilterModal ref={multiFilterRef} filters={filterOptions} />
      </div>
    </div>
  );
};

export default TeamFilters;
